var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#ECEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9052 22.4397C21.3265 23.7704 19.2786 24.5737 17.0409 24.5737C12.0478 24.5737 8 20.5741 8 15.6404C8 10.7066 12.0478 6.70703 17.0409 6.70703C19.2786 6.70703 21.3265 7.51032 22.9052 8.84098C24.4839 7.51032 26.5317 6.70703 28.7694 6.70703C33.7626 6.70703 37.8104 10.7066 37.8104 15.6404C37.8104 20.5741 33.7626 24.5737 28.7694 24.5737C26.5317 24.5737 24.4839 23.7704 22.9052 22.4397Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9053 22.4396C24.8492 20.8011 26.0818 18.363 26.0818 15.6404C26.0818 12.9178 24.8492 10.4796 22.9053 8.84108C24.484 7.51036 26.5319 6.70703 28.7697 6.70703C33.7628 6.70703 37.8106 10.7066 37.8106 15.6404C37.8106 20.5741 33.7628 24.5737 28.7697 24.5737C26.5319 24.5737 24.484 23.7704 22.9053 22.4396Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9052 22.4406C20.9612 20.802 19.7285 18.3638 19.7285 15.6412C19.7285 12.9185 20.9612 10.4803 22.9052 8.8418C24.8492 10.4803 26.0818 12.9185 26.0818 15.6412C26.0818 18.3638 24.8492 20.802 22.9052 22.4406Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6389514a08853351c2755b43990d012c.svg";
export { ForwardRef as ReactComponent };